import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGrid: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconGrid"><Path d="M8.5 3.75V20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><Path d="M15.5 3.75V20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><Path d="M3.75 8.5H20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><Path d="M3.75 15.5H20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></CentralIconBase>;
});

export default IconGrid;
